import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";

export default function BrokerageForexLicenses
    (){

    return (
        <main className='main'>

            <IntroSection
                title="Brokerage & Forex Licenses"
                subtitle="Launch Your Brokerage with Global Licensing Solutions"
                description =
                    "
                    <b>Offshore Advisory</b> provides <b>full support</b> for obtaining <b>Brokerage, Forex, and Investment Licenses</b> across <b>multiple jurisdictions</b>. Whether you want to start a <b>forex brokerage</b>, <b>CFD platform</b>, <b>investment advisory firm</b>, or <b>prop trading company</b>, we deliver the <b>regulatory approvals</b>, <b>corporate structuring</b>, and <b>banking access</b> you need.
                    "
                badges={
                    [
                        "Forex & CFD Licenses",
                        "Investment Brokerage",
                        "Crypto-Brokerage",
                        "Prop Trading Structures"
                    ]
                }
                buttonText="Request a Brokerage License Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/brokerage-forex-licenses-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Do You Need a Brokerage License?'
                        subtitle='Operating a brokerage without a license limits your growth and credibility. With a license, you gain:'
                        blocks={[
                            {
                                items:
                                    [
                                        { title: "Legal Recognition", text: "operate in regulated markets" },
                                        { title: "Access to Banking & PSPs", text: "secure payment processing and corporate accounts" },
                                        { title: "Client Trust", text: "licensed brokers attract more traders and investors" },
                                        { title: "Global Expansion", text: "market in regions requiring licensed entities" }
                                    ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Types of Brokerage Licenses We Support"
                        item={
                            [
                                { title: "Forex Broker License", text: "STP, ECN, or Market Maker models" },
                                { title: "CFD & Derivatives License", text: "commodities, indices, crypto CFDs" },
                                { title: "Securities Brokerage License", text: "stocks, bonds, ETFs" },
                                { title: "Investment Advisory License", text: "portfolio management, financial consultancy" },
                                { title: "Crypto-Brokerage & Hybrid Models", text: "crypto + forex" },
                                { title: "Prop Trading Company Setup", text: "funded trader models" }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Jurisdictions for Brokerage Licenses"
                        blocks={[
                            {
                                title: "Offshore / Fast-Track",
                                items:
                                    [
                                        { title: "Western Sahara (CRA)", text: "Forex, CFD, and crypto-friendly licenses" },
                                        { title: "Mwali (Comoros)", text: "Recognized forex brokerage licensing" },
                                        { title: "Anjouan (Comoros)", text: "Fast approval, lower capital requirements" },
                                        { title: "Vanuatu", text: "Popular offshore FX licensing hub" },
                                        { title: "Seychelles", text: "Flexible and internationally accepted" }
                                    ]
                            },
                            {
                                title: "Mid-Tier / Onshore",
                                items:
                                    [
                                        { title: "Mauritius", text: "Investment Dealer License, strong credibility in Africa & Asia" },
                                        { title: "St. Lucia", text: "Attractive forex and securities licensing" },
                                        { title: "Belize", text: "Affordable brokerage license with growing recognition" }
                                    ]
                            },
                            {
                                title: "Top-Tier / EU",
                                items:
                                    [
                                        { title: "Cyprus (CySEC)", text: "MiFID-compliant EU Investment Firm License" },
                                        { title: "Malta (MFSA)", text: "EU-wide passporting rights" },
                                        { title: "UK (FCA)", text: "Highly reputable, strict compliance (costly & time-consuming)" }
                                    ]
                            },

                        ]}
                    />


                    <FeatureCards
                        title='Our Brokerage License Services Include'
                        features={
                            [
                                { title: "Company Incorporation", text: "in chosen jurisdiction" },
                                { title: "License Application & Regulatory Submissions", text: "" },
                                { title: "Compliance Framework", text: "AML/KYC, policies, manuals" },
                                { title: "Banking & Payment Gateway Integration", text: "" },
                                { title: "MT4/MT5 White-Label Solutions", text: "" },
                                { title: "Liquidity Provider Introductions", text: "forex & crypto liquidity" },
                                { title: "Nominee Director & Local Office Services", text: "where required" }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timelines'
                        items={[
                            {
                                name: "Offshore Licenses (Mwali, Anjouan, Western Sahara)",
                                duration: " 4-8 weeks",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Mid-Tier (Mauritius, St. Lucia, Belize)",
                                duration: "2-4 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "EU / FCA / Tier-1",
                                duration: "6-12 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <TimelineSection
                        title='Cost'
                        items={[
                            {
                                name: "Offshore licenses",
                                duration: "USD 15,000 – 30,000",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Mid-tier licenses",
                                duration: "USD 35,000 – 60,000",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "EU Tier-1 licenses",
                                duration: "USD 100,000+",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                        end='(Ongoing annual fees apply depending on jurisdiction.)'
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                                Ready to launch your brokerage?
                             "
                         description=
                             "
                                From <b>offshore FX licenses</b> to <b>EU MiFID licenses</b>, <b>Offshore Advisory</b> provides <b>end-to-end brokerage licensing solutions</b>.
                             "
                         buttonText='Book a Free Brokerage Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Which brokerage license is best for startups?",
        content: [
            { type: "answer", text: "Western Sahara, Anjouan, and Mwali are affordable and fast for new brokers." },
        ],
    },
    {
        question: "Can I operate globally with an offshore license?",
        content: [
            { type: "answer", text: "Yes, offshore licenses are widely accepted, but EU/UK markets often require EU-regulated brokers." },
        ],
    },
    {
        question: "What technology do I need?",
        content: [
            { type: "answer", text: "We provide white-label MT4/MT5 setups, trading platforms, and liquidity integrations." },
        ],
    },
    {
        question: "How much capital is required?",
        content: [
            { type: "answer", text: "Depends on jurisdiction: offshore requires lower capital ($10k–$50k), while EU/UK requires higher (€125k–€750k regulatory capital)." },
        ],
    },
    {
        question: "Do you assist with compliance?",
        content: [
            { type: "answer", text: "Yes — we prepare AML/KYC policies, risk management frameworks, and appoint MLRO/compliance officers." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "Offshore Advisory helped us obtain a forex license in Mwali and set up our MT5 white-label. We were live in 6 weeks.",
            author: "David M.",
            role: "Forex Broker"
        },
        {
            quote: "They guided us through a Mauritius Investment Dealer License and connected us with liquidity providers. Highly professional.",
            author: "Sarah L.",
            role: "Brokerage Founder"
        }
    ]
;